import {Body, Head} from "./lib";
import {Box} from "react-feather";
import {useAppSelector} from "hooks";
import {Column, Skeleton, ComponentLoader} from "components";
import {TableContainer, Table as MUITable} from "@mui/material";

interface TableProps {}

export const Table: React.FC<TableProps> = () => {
  const {client, request} = useAppSelector("clients");
  const {formularios} = client;

  const emptyMessage = "No se han encontrado créditos";

  return (
    <div style={{width: "100%"}}>
      <ComponentLoader
        requestStatus={request["clientProducts"]}
        skeleton={
          <Column width="100%">
            <Skeleton height={60} width="100%" />
            <Column gap={2} width="100%">
              <Skeleton count={5} height={68} width="100%" />
            </Column>
          </Column>
        }
        emptyUI={{
          icon: Box,
          data: formularios,
          message: emptyMessage,
          style: {width: "100%"},
        }}
      >
        <TableContainer>
          <MUITable size="medium" sx={{minWidth: 750}}>
            <Head />
            <Body />
          </MUITable>
        </TableContainer>
      </ComponentLoader>
    </div>
  );
};
